import React from 'react';

import {LocationDescriptor} from 'history';
import {IndexLinkProps, Link, withRouter, WithRouterProps} from 'react-router';

/*
we can get rid of all this when update to react-router 4
since it supports replace prop natively
*/
function resolveToLocation(
  to: IndexLinkProps['to'],
  location: WithRouterProps['location']
): LocationDescriptor {
  return typeof to === 'function' ? to(location) : to;
}

function isLeftClickEvent(event: React.MouseEvent): boolean {
  return event.button === 0;
}

function isModifiedEvent(event: React.MouseEvent): boolean {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

export interface OwnProps
  extends Pick<
    IndexLinkProps,
    | 'to'
    | 'target'
    | 'onClick'
    | 'title'
    | 'className'
    | 'activeClassName'
    | 'children'
  > {
  replace?: boolean;
}

export interface Props extends WithRouterProps, OwnProps {}

export const ReplaceableLink = withRouter(
  ({router, location, to, target, replace, onClick, ...other}: Props) => {
    const handleClick = (ev: React.MouseEvent) => {
      if (onClick) {
        onClick(ev);
      }
      if (replace) {
        if (isModifiedEvent(ev) || !isLeftClickEvent(ev) || target != null) {
          return;
        }
        ev.preventDefault();
        const resolvedLocation = resolveToLocation(to, location);
        router.replace(resolvedLocation);
      }
    };

    return <Link to={to} target={target} onClick={handleClick} {...other} />;
  }
);
